<script setup>
import { useI18n } from '../../i18n.js'
import { auditCategories } from '../../monitoring/journalState.js'
import JournalPeriodFields from './JournalPeriodFields.vue'
import JournalOutcomeFields from './JournalOutcomeFields.vue'
import JournalOptionSelect from './JournalOptionSelect.vue'
defineProps({ model: Object, sources: Array, options: Object, invalid: Boolean })
const emit = defineEmits(['options'])
const { t } = useI18n()
</script>
<template>
  <JournalPeriodFields :model="model" journal="audit" :invalid="invalid" />
  <div class="journal-filter-fields">
    <label>{{ t('auditCategory') }}<select v-model="model.category" :aria-label="t('auditCategory')"><option value="">{{ t('allCategories') }}</option><option v-for="[value, label] in auditCategories" :key="value" :value="value">{{ t(label) }}</option></select></label>
    <JournalOutcomeFields :model="model" />
    <JournalOptionSelect v-model="model.actor" :label="t('auditActor')" :all-label="t('allUsers')" :state="options.actor" @load="(page, q) => emit('options', 'actor', page, q)" />
    <label>{{ t('journalWorkplace') }}<select v-model="model.sourceInstanceId" :aria-label="t('journalWorkplace')"><option value="">{{ t('journalAllWorkplaces') }}</option><option v-for="source in sources" :key="source.id" :value="String(source.id)">{{ source.displayName }}</option></select></label>
  </div>
</template>
